export default {
  journey: {
    get: {
      method: 'post',
      url: 'monitoring/journeys'
    },
    getDetail: {
      method: 'get',
      url: 'monitoring/journeys/ID'
    },
    getDocuments: {
      method: 'get',
      url: 'monitoring/journeys/ID/document'
    },
    setActualTime: {
      method: 'post',
      url: 'monitoring/journeys/ID/actual-time'
    },
    setActualTimeMultiple: {
      method: 'post',
      url: 'monitoring/journeys/ID/actual-time-multiple'
    },
    setActualTimeBegin: {
      method: 'post',
      url: 'monitoring/journeys/ID/actual-time/start'
    },
    setActualTimeStop: {
      method: 'post',
      url: 'monitoring/journeys/ID/actual-time/stop'
    },
    setJobCompleteTime: {
      method: 'post',
      url: 'monitoring/journeys/ID/job-complete-time'
    },
    updatePlanning: {
      method: 'post',
      url: 'monitoring/journeys/ID/planning'
    },
    file: {
      get: {
        method: 'get',
        url: 'monitoring/journeys/ID/files'
      },
      upload: {
        method: 'post',
        url: 'monitoring/journeys/ID/files'
      },
      edit: {
        method: 'put',
        url: 'monitoring/journeys/ID/files/ID_FILE'
      },
      delete: {
        method: 'delete',
        url: 'monitoring/journeys/ID/files/ID_FILE'
      },
      taskOptions: {
        method: 'get',
        url: 'monitoring/journeys/ID/task-options'
      }
    },
    alert: {
      get: {
        method: 'post',
        url: 'monitoring/journeys/ID/alerts'
      }
    },
    activities: {
      get: {
        method: 'post',
        url: 'monitoring/journeys/ID/activities'
      }
    },
    read: {
      method: 'post',
      url: 'monitoring/journeys/ID/read'
    },
    pricing: {
      update: {
        method: 'post',
        url: 'monitoring/journeys/ID/prices'
      }
    },
    changeVehicle: {
      method: 'post',
      url: 'monitoring/journeys/ID/change-vehicle'
    },
    changeVehicleAndMooc: {
      method: 'post',
      url: 'monitoring/journeys/ID/change-vehicle-and-mooc'
    }
  },
  vehicle: {
    get: {
      method: 'post',
      url: 'monitoring/vehicles'
    }
  },
  alert: {
    get: {
      method: 'post',
      url: 'monitoring/alerts'
    },
    skip: {
      method: 'post',
      url: 'monitoring/journeys/ID/alerts/ALERT_ID/skip'
    },
    scheduleSkip: {
      method: 'post',
      url: 'monitoring/journeys/ID/schedule-alerts/ALERT_ID/skip'
    }
  }
}
